import { render, staticRenderFns } from "./AreaSourceDetailInner.vue?vue&type=template&id=fe8d6f08&scoped=true&"
import script from "./AreaSourceDetailInner.vue?vue&type=script&lang=js&"
export * from "./AreaSourceDetailInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8d6f08",
  null
  
)

export default component.exports